<template>
  <div>
    <div v-if="form.data.company == undefined">
      <div class="is-flex is-align-items-center is-flex-direction-column">
        <img src="/trophy.svg" width="100px">
        <div class="fireworks_animation"></div>
        <p>כל הכבוד על ההשמה שלך <b>{{$utils.getOwner().name}}</b>!</p>
      </div>
      <div v-if="is_loading" class="is-flex is-flex-direction-column is-align-items-center" style="margin-top: 10px;">
        <div class="loading"></div>
        <p>טוען מידע...</p>
      </div>
    </div>
    <div v-if="is_loading == false">
      <accounting-company-form ref="accounting_company_form" v-model="form.data.company" :payload="{ company: payload.data.position.company }"
                               @select_company="selectCompany">
      </accounting-company-form>
      <accounting-offer-form ref="accounting_offer_form" v-if="isShowOfferForm" :offer="payload.data" v-model="form.data.offer" @cancel="onOfferCanceled">
      </accounting-offer-form>
    </div>
    <div v-if="isShowOfferForm" class="vertical_space"></div>
    <div class="vertical_space"></div>
    <div class="modal_footer">
      <a
        @click="preSubmit"
        :class="{ 'is-loading': is_submitting, faded: !isShowOfferForm || is_submitted }"
        class="button is-info mr-5"
        >Submit</a
      >
      <WhatsAppLink ref="whatsapp-vested" v-bind="offers_helper.getWhatsAppLinkPayload(payload.data, whatsappTemplate)"/>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import OffersHelper from '@/custom/classes/offers_helper'
import AccountingCompanyForm from '@/components/AccountingCompanyForm'
import AccountingOfferForm from '@/components/AccountingOfferForm'
import WhatsAppLink from '@/components/WhatsAppLink'
export default {
  name: 'vested',
  props: ['payload'],
  data () {
    return {
      offers_helper: new OffersHelper(),
      is_loading: true,
      is_submitting: false,
      is_submitted: false,
      env: this.$settings.get({ path: 'operation_name' }),
      form: new this.$form({
        offer: undefined,
        company: undefined
      })
    }
  },
  mounted () {
    this.sendEmail()
    this.getDataFromAccountingService()
  },
  computed: {
    isShowOfferForm () {
      if (this.form.data.company == undefined) {
        return false
      }
      return this.form.data.company.fields.id.value != ''
    },
    whatsappTemplate () {
      const env = this.$settings.get({ path: 'operation_name' })
      switch (env) {
        case 'Rebase':
          return 'rebaseVestingMessage'
        case 'Piola':
          return 'piolaVestingMessage'
        case 'Bullrun':
          return 'bullrunVestingMessage'
        case 'Suitup':
        default:
          return 'suitupVestingMessage'
      }
    }
  },
  methods: {
    sendEmail () {
      this.$network_utils.postEvent({
        current_type: 'Offer',
        current_resource_id: this.payload.data.id,
        event: 'recruiter_clicked_vested',
        owner: this.$utils.getOwner().name,
        offer_id: this.payload.data.id
      })
    },
    getDataFromAccountingService () {
      let accounting_company_request = this.$network_utils.getAccountingCompany({ env: this.env, env_company_id: this.payload.data.position.company.resource_id })
      let accounting_offer_request = this.$network_utils.getAccountingOffer({ env: this.env, env_offer_id: this.payload.data.id })
      this.$network_utils.caller.axios.all([accounting_company_request, accounting_offer_request]).then(response => {
        this.is_loading = false
        this.$nextTick(() => {
          this.injectExistingData(response)
        })
      })
    },
    injectExistingData (response) {
      let accounting_company = response[0]
      this.selectCompany(accounting_company)
      this.$nextTick(() => {
        let accounting_offer = response[1]
        this.selectOffer(accounting_offer)
      })
    },
    selectCompany (company) {
      if (company == undefined) {
        return
      }
      this.$refs.accounting_company_form.selectCompany(company)
      this.$nextTick(() => {
        this.$refs.accounting_offer_form.setCompanyData(company)
      })
    },
    selectOffer (offer) {
      if (offer == undefined) {
        return
      }
      this.$refs.accounting_offer_form.selectOffer(offer)
    },
    showCreateCompanyForm () {
      this.form.data.company.fields.name.value = this.company_search_term
      this.show_create_company_form = true
      this.companies_search_results = []
    },
    preSubmit () {
      this.create({
        designator: 'done-confirmation-modal',
        component_name: 'ModalConfirmation',
        show_close_button: false,
        ignore_escape_button: true,
        modal_title: 'Message Applicant',
        modal_width: '300px',
        props: {
          message: 'האם תרצי לשלוח הודעת וואטסאפ למועמד?',
          onConfirmation: (id) => {
            this.$refs['whatsapp-vested']._vnode.children[0].elm.click()
            this.submit()
            this.removeModalById(id)
          },
          onReject: (id) => {
            this.submit()
            this.removeModalById(id)
          }
        }
      })
    },
    submit () {
      if (this.form.data.offer.request_details.method == 'post') {
        this.form.data.offer.fields.status = {
          value: 'vesting',
          has_error: false,
          validations: ['Exists']
        }
      }
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_submitting = true
      response.promise.then((response) => {
        this.updateOfferData()
        this.freezeApplicant()
        this.remove(this.payload)
        this.is_submitting = false
        this.is_submitted = true
        this.$utils.emit('show_toast', { text: 'השמה נוצרה בהצלחה במערכת Accounting' })
      })
    },
    updateOfferData () {
      this.offers_helper.changeOfferStatus({
        offer: this.payload.data,
        new_data: { status: 'vesting', message: this.form.data.offer.fields.message.value }
      })
    },
    freezeApplicant () {
      this.$network_utils.updateApplicant({ applicant_id: this.payload.data.applicant.resource_id, freezed_until: this.$moment().add(1, 'Y').format() }).then(() => {
        this.$utils.emit('show_toast', { text: 'תאריך הקפאה עודכן' })
      })
    },
    onOfferCanceled () {
      this.remove(this.payload)
    },
    ...mapMutations('modals', ['create', 'remove', 'removeModalById'])
  },
  components: {
    AccountingCompanyForm,
    AccountingOfferForm,
    WhatsAppLink
  }
}
</script>
<style>
  .section_title{
    font-size: 22px !important;
    text-decoration: underline;
  }
  .small_input{
    padding-right: 2px !important;
    padding-left: 2px !important;
    text-align: center;
    width: 84px;
  }
  .percentage_different{
    border-radius: 4px;
    margin-right: 10px;
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
  }
</style>
